<template>
  <v-dialog v-if="isInErrorMode" v-model="isInErrorMode" :width="300" :max-width="300" :min-width="300">
    <v-container fill-height :width="300" class="ma-0 pa-0" style="overflow: hidden;">
      <v-row justify="center" align="center" class="pa-0 ma-0" :class="fp.isInMode(Const.Modes.Info)?'info':' error'">
        <v-spacer></v-spacer>
        <div class="white--text">{{ fp.isInMode(Const.Modes.Info)? 'Информация':'Внимание' }}</div>
        <v-spacer></v-spacer>
        <v-btn color="white" text fab small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-alert :dismissible="isDismissible" :type="fp.isInMode(Const.Modes.Info)?'info':'error'" @input="showStatus" close-icon="mdi-comment-question" class="ma-0" :width="300"><span style="white-space: pre-wrap;">{{ fp.getErrorMessage() }}</span></v-alert>
    </v-container>
  </v-dialog>
</template>
<script>
import Const from "../constants";

export default {
  data() {
    return {
      Const: Const
    };
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.Error);
      this.fp.exitMode(Const.Modes.Info);
    },
    showStatus() {
      this.fp.addMode(Const.Modes.Status);
    }
  },
  computed: {
    /** @return {Boolean} */
    isDismissible() {
      return this.fp.__errorShowStatus;
    },
    /** @return {Boolean} */
    isInErrorMode: {
      /** @return {Boolean} */
      get() {
        return this.fp.isInMode(Const.Modes.Error) || this.fp.isInMode(Const.Modes.Info);
      },
      /** @return {Void} */
      set(value) {
        if (this.fp.isInMode(Const.Modes.Error)) {
          if (value) this.fp.addMode(Const.Modes.Error);
          else this.fp.exitMode(Const.Modes.Error);
        } else if (this.fp.isInMode(Const.Modes.Info)) {
          if (value) this.fp.addMode(Const.Modes.Info);
          else this.fp.exitMode(Const.Modes.Info);
        }
      }
    }
  }
};
</script>